import { render, staticRenderFns } from "./OrderListModal.vue?vue&type=template&id=232d9587&scoped=true"
import script from "./OrderListModal.vue?vue&type=script&lang=js"
export * from "./OrderListModal.vue?vue&type=script&lang=js"
import style0 from "./OrderListModal.vue?vue&type=style&index=0&id=232d9587&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232d9587",
  null
  
)

export default component.exports